<template>
  <div class="list bgc3">
    <Header :title="$t('m.MeetingTemplateDetail')"></Header>
    <div class="content spebgc">
      <div class="item">
        <span class="item_label">{{$t('m.TemplateName')}}</span>
        <span class="item_content">
          <input
            :placeholder="$t('m.PlsEnterMeetingTemplateName')"
            style="width:100%;border:none;outline:none;height:0.45rem"
            type="text"
            v-model="meeting.meeting_templatename"
          />
        </span>
      </div>
      <div class="item">
        <span class="item_label">{{$t('m.MeetingName')}}</span>
        <span class="item_content">
          <input
            :placeholder="$t('m.PlsEnterMeeetingNO')"
            style="width:100%;border:none;outline:none;height:0.45rem"
            type="text"
            v-model="meeting.meeting_name"
          />
        </span>
      </div>
      <div class="item">
        <span class="item_label">{{$t('m.MeetingType')}}</span>
        <RadioGroup v-model="meeting.meeting_type">
          <Radio label="1">
            <span>{{$t('m.InstantConference')}}</span>
          </Radio>
          <Radio label="2">
            <span>{{$t('m.ReservedConference')}}</span>
          </Radio>
        </RadioGroup>
      </div>
      <div
        class="item"
        style="height:auto;padding:0.1rem 0;line-height:0.3rem;box-sizing:content-box"
      >
        <span class="item_label">{{$t('m.MeetingIntroduce')}}</span>
        <span style="width:75%">
          <Input
            :placeholder="$t('m.PlsEnterMeetingIntroduce')"
            style="margin:0;padding:0; background: transparent;cursor:pointer;outline:none"
            type="textarea"
            v-model="meeting.meeting_content"
          />
        </span>
      </div>
      <div
        class="item"
        style="height:auto;padding:0.10rem 0;line-height:0.3rem;box-sizing:content-box"
        @click="tochoicepeople"
      >
        <span class="item_label">{{$t('m.Participants')}}</span>
        <span>
          <img :src="imgpath.people" style="width:0.2rem;vertical-align: middle" />
        </span>
        {{peoplechoice}}
      </div>
      <div
        class="item"
        style="height:auto;padding:0.10rem 0;line-height:0.3rem;box-sizing:content-box"
        @click="tochoiceroom"
      >
        <span class="item_label">{{$t('m.ConferenceTerminal')}}</span>
        <span>
          <img :src="imgpath.room" style="width:0.2rem;vertical-align: middle" />
        </span>
        {{roomchoice}}
      </div>
      <div
        class="item"
        style="height:auto;padding:0.10rem 0;line-height:0.3rem;box-sizing:content-box"
        @click="tochoicehost"
      >
        <span class="item_label">{{$t('m.ConferenceHost')}}</span>
        <span>
          <img :src="imgpath.people" style="width:0.2rem;vertical-align: middle" />
        </span>
        {{hostchoice}}
      </div>
      <div class="item" v-if="showRecordAndLive" style="margin-bottom: 45px;">
        <CheckboxGroup style="float:left" v-model="meeting.cf_record">
          <Checkbox label="1">
            <span>{{$t('m.ConferenceRecord')}}</span>
          </Checkbox>
        </CheckboxGroup>
        <CheckboxGroup style="float:left" v-model="meeting.cf_live">
          <Checkbox label="1">
            <span>{{$t('m.ConferenceLive')}}</span>
          </Checkbox>
        </CheckboxGroup>
      </div>
      <div class="button bgc" @click="sure">{{$t('m.OKBtn')}}</div>
    </div>
    <div class="pop" v-if="editsure">
      <div class="templatepopexit">
        <div class="popclosex" @click="editsure=false">
          <Icon type="ios-close"></Icon>
        </div>
        <div class="title-line">
          <img class="iconimg" :src="hookUrl" />
          <span class="title_sure">{{$t('m.ModifyBtn')}}</span>
        </div>
        <div class="templatepoptop">{{$t('m.TemplateName')}}会议（{{meeting.meeting_name}}）{{$t('m.ModifyOK')}}</div>
        <div @click="editsure=false" class="templatepopbottomexit color bdc">{{$t('m.CancelBtn')}}</div>
        <div @click="editsureSuccess" class="templatepopbottomexit bgc">{{$t('m.OKBtn')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../../header/header";
import "../../../../static/css/normalize3.0.2.min.css";
import "../../../../static/css/style.css?v=7";
import "../../../../static/css/mobiscroll.css";
import "../../../../static/css/mobiscroll_date.css";
import {
  getMeetingTemplateInfo,
  update_MeetingTemplateById,
  beforeCreateMeeting
} from "../../../assets/js/url";

export default {
  name: "attendmeeting",
  data() {
    return {
      editsure: false,
      hookUrl: require("@/assets/images/public/hook.png"),
      meeting_templateid: "",
      meeting: {
        useruuid: window.sessionStorage.getItem("UUID"),
        meeting_templatename: "",
        meeting_name: "",
        password_display: "",
        meeting_type: "1",
        meeting_content: "  ",
        vmr_id: "",
        cf_party: "",
        cf_terminal: "",
        cf_host: "",
        cf_record: [],
        cf_live: []
      },
      showRecordAndLive: false
    };
  },
  computed: {
    imgpath() {
      return this.$store.state.imagestyle[this.$store.state.cssstyle];
    },
    peoplechoice() {
      return this.$store.state.meeting.cfpartyname.replace(/,/g, "，");
    },
    hostchoice() {
      return this.$store.state.meeting.cfhostname.replace(/,/g, "，");
    },
    roomchoice() {
      return this.$store.state.meeting.cfterminalname.replace(/,/g, "，");
    }
    // hasmediasuite() {
    //   return this.$store.state.hasmediasuite;
    // }
  },
  components: {
    Header
  },

  activated() {
    this.meeting_templateid = this.$route.query.meeting_templateid;
    this.getMeetingIsShow();

    if (this.$route.query.isTrue == true) {
      this.loadTemplateData();
    }
  },

  methods: {
    // 记录store归零，暂时不用
    attendinit() {
      this.$store.commit("setmeetingcfparty", "");
      this.$store.commit("setmeetingcfpartyname", "");
      this.$store.commit("setmeetingcfhost", "");
      this.$store.commit("setmeetingcfhostname", "");
      this.$store.commit("setmeetingcfterminal", "");
      this.$store.commit("setmeetingcfterminalname", "");
    },
    getMeetingIsShow() {
      this.$http.post(beforeCreateMeeting, {}).then(res => {
        if (res.data.status == 2000) {
          let data = res.data.data;
          this.showRecordAndLive = data.showRecordAndLive;
        }
      });
    },
    loadTemplateData: function() {
      this.$loadingshow();
      this.meeting_templateid = this.$route.query.meeting_templateid;
      this.$http
        .post(getMeetingTemplateInfo, {
          meeting_templateid: this.meeting_templateid
        })
        .then(res => {
          this.$loadingclose();
          if (res.data.status === 2000) {
            this.dataCount = res.data.dataCount;
            let data = res.data.data;
            this.meeting.meeting_templatename = data.meeting_templatename;
            this.meeting.meeting_name = data.meeting_name;
            this.meeting.meeting_type = data.meeting_type + "";
            this.meeting.meeting_content = data.meeting_content;
            this.$store.commit("setmeetingcfhost", data.cf_host);
            this.$store.commit("setmeetingcfhostname", data.cf_host_name);
            this.$store.commit("setmeetingcfparty", data.cf_party);
            this.$store.commit("setmeetingcfpartyname", data.cf_party_name);
            this.$store.commit("setmeetingcfterminal", data.cf_terminal);
            this.$store.commit(
              "setmeetingcfterminalname",
              data.cf_terminal_name
            );
            this.meeting.cf_live = data.cf_live == 1 ? ["1"] : [];
            this.meeting.cf_record = data.cf_record == 1 ? ["1"] : [];
            this.meeting.id = data.id;
          }
        });
    },
    tochoicepeople() {
      this.$router.push({
        path: "/userlist",
        query: {
          name: "cfparty",
          canChoose: true,
          message: this.$store.state.meeting.cfparty //要在通讯录中把人标出来
        }
      });
    },
    tochoicehost() {
      this.$router.push({
        path: "/userlist",
        query: {
          name: "cfhost", //用这个字段区分
          canChoose: true,
          message: this.$store.state.meeting.cfhost //要在通讯录中把人标出来
        }
      });
    },
    tochoiceroom() {
      this.$router.push({
        name: "terminalcontrolPctest",
        query: {
          name: "cfterminal", //用这个字段区分
          message: this.$store.state.meeting.cfterminal,
          meetingType: this.meeting.meeting_type, //会议类型
          dateTimeValue: "" //在这个时间下
        },
        params: {
          meeting_vrmId: 0,
          creatingTime:
            this.meeting.meeting_type == "2"
              ? this.datavalue + " " + this.timevalue + ":00"
              : ""
        }
      });
    },

    sure() {
      if (!this.meeting.meeting_name) {
        this.$toast(this.$t('m.MeetingNameNotNull'));
        return;
      }

      this.meeting.cf_party = this.$store.state.meeting.cfparty;
      this.meeting.cf_host = this.$store.state.meeting.cfhost;
      this.meeting.cf_terminal = this.$store.state.meeting.cfterminal;
      const data = Object.assign({}, this.meeting);
      data.cf_live = this.meeting.cf_live.length == 0 ? "2" : "1";
      data.cf_record = this.meeting.cf_record.length == 0 ? "2" : "1";
      data.useruuid = window.sessionStorage.getItem("UUID");

      this.$loadingshow();
      this.$http.post(update_MeetingTemplateById, data).then(res => {
        this.$loadingclose();
        if (res.data.status == 2000) {
          this.editsure = true;
        } else {
          this.$toast(res.data.data.errorDes || this.$t('m.OperateFail'));
        }
      });
    },
    editsureSuccess() {
      this.editsure = false;
    }
  }
};
</script>
<style scoped>
.list {
  width: 100%;
  overflow: hidden;
}

.nav {
  height: 0.65rem;
  background-color: #fff;
  padding: 0.15rem 0.1rem;
  box-sizing: border-box;
}

input {
  background: transparent;
}

input:disabled {
  background: transparent;
  font-size: 0.14rem;
}

input:disabled:-moz-placeholder {
  color: #ddd;
  font-size: 0.14rem;
}

input:disabled:-ms-input-placeholder {
  color: #ddd;
  font-size: 0.14rem;
}

input:disabled::-webkit-input-placeholder {
  color: #ddd;
  font-size: 0.14rem;
}

input::-webkit-input-placeholder {
  font-size: 0.14rem;
}

.nav table {
  width: 100%;
  height: 0.38rem;
  border-radius: 4px;
  border-collapse: collapse;
  line-height: 0.35rem;
}

.nav table tr {
  height: 0.36rem;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
}

.nav table tr td {
  width: 33.3333%;
  text-align: center;
  font-size: 0.13rem;
}

td.normal {
  border-top: none;
  border-bottom: none;
  border-left: none;
}

td.normal.active {
  color: #fff;
}

.content {
  /* margin-top: 0.1rem; */
  padding: 0 0.15rem;
  background: #fff;
}

.radio {
  width: 0.15rem;
  height: 0.15rem;
  display: inline-block;
  border-radius: 100%;
  vertical-align: middle;
}

i {
  font-size: 0.25rem;
  vertical-align: middle;
}

.button {
  width: 100%;
  height: 0.44rem;
  color: #fff;
  text-align: center;
  line-height: 0.44rem;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
}

.modelwrap {
  width: 100%;
  height: 100%;
  top: 0.44rem;
  left: 0px;
  position: fixed;
  background: rgba(0, 0, 0, 0.4);
}

.model {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -0.54rem;
  margin-left: -1.35rem;
  width: 2.7rem;
  height: 1.08rem;
  background-color: #fff;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 0.2rem 0.06rem;
}

.modeltitle {
  text-align: center;
  height: 0.34rem;
  line-height: 0.34rem;
  font-size: 0.17rem;
  color: #000;
}

.modelact {
  text-align: center;
  height: 0.34rem;
  line-height: 0.34rem;
  font-size: 0.17rem;
  color: #000;
}

.date {
  width: 100%;
  border: 1px solid #ccc;
  outline: none;
  height: 0.3rem;
  line-height: 0.3rem;
  vertical-align: middle;
  border-radius: 3px;
  background-color: #fff;
  background: url("../../../assets/images/public/down.png") no-repeat 1.1rem
    center;
  background-size: 0.15rem 0.1rem;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/components/content/indextomeeting/meetingtemplate_edit.vue